import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import DropDown from 'src/components/design-system/DropDown';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import { DropDownListData } from 'src/types/generic';

const ItemNoteDropDownCell = (props: GridCellProps) => {
  const { dataItem, dataIndex, field = '' } = props;
  const dataValue = dataItem[field] || '';
  const { receiptItemNotes, receiptData } = useReceiptDetails();

  const options: DropDownListData = receiptItemNotes.map((item) => ({
    label: item.itemNoteValue,
    value: item.itemNoteId.toString(),
  }));

  const handleChange = useCallback(
    (e: DropDownListChangeEvent) => {
      props.onChange?.({
        dataIndex,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e?.value.label,
      });
      props.onChange?.({
        dataIndex,
        dataItem: props.dataItem,
        field: 'itemNoteId',
        syntheticEvent: e.syntheticEvent,
        value: Number(e?.value.value),
      });
    },
    [dataIndex, props]
  );

  const isInProgress = useMemo(
    () => receiptData.receiptStatus.toLowerCase() === 'in progress',
    [receiptData?.receiptStatus]
  );

  return (
    <GridCellBase {...props} title={dataValue}>
      {isInProgress ? (
        <DropDown
          onChange={handleChange}
          value={dataItem.itemNoteId.toString()}
          options={options}
        />
      ) : (
        dataValue
      )}
    </GridCellBase>
  );
};

export default ItemNoteDropDownCell;
